<template>
  <div data-cy="partner-logo" :class="logoStyles">
    <img
      v-if="branding?.logo"
      class="h-full w-full object-contain"
      :src="branding.logo.file_url"
      alt="logo"
      data-cy="partner-logo"
    />
    <icon-lendflow v-else data-cy="defaultLogo" />
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { useResponsive } from "@/composables/common";
import useBrandingState from "@/composables/state/brandingState";
import IconLendflow from "@/components/icons/IconLendflow.vue";

const { branding } = useBrandingState();
const { isMobile } = useResponsive();

const logoStyles = computed(() =>
  isMobile.value
    ? "min-w-4 min-h-4 w-6 h-6"
    : "bg-branding-icon min-w-12 min-h-12 w-12 h-12 rounded-full flex items-center justify-center border border-gray-300 border-3 overflow-hidden"
);
</script>
